import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { Sc3FailedMessagesListFacade } from './sc3-failed-messages-list.facade';

@Injectable({
  providedIn: 'root',
})
export class Sc3FailedMessagesListGuard {
  constructor(private sc3FailedMessagesListFacade: Sc3FailedMessagesListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.sc3FailedMessagesListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.sc3FailedMessagesListFacade);
  }
}
